export const changeLogSections = {
  PROPERTY: 'details',
  ADDRESS: 'address',
  PROPERTY_ADDRESS: 'details_and_address',
  PROPERTY_FACILITY: 'facilities',
  UNIT_TYPE: 'rooms',
  LISTING: 'listings',
};

export const changeLogUnitType = {
  bathroomCount: 'number_of_bathrooms',
  kitchenArrangement: 'kitchen_arrangement',
  floors: 'label_floor_no',
  bathroomType: 'bathroom_arrangement',
  categorySlug: 'category',
  maxOccupancy: 'max_occupancy',
  arrangement: 'room_arrangement',
  name: 'room_name',
  kitchenCount: 'number_of_kitchens',
  bedCount: 'number_of_beds',
  bedroomCountMax: 'max_number_of_bedrooms',
  roomType: 'room_type',
  genderMix: 'gender_mix',
  lastFurnished: 'latest_furnished',
  roomSize: 'room_size',
  viewType: 'view_type',
  bedSizeType: 'bed_size_type',
  bedroomCountMin: 'min_number_of_bedrooms',
  dietaryPreference: 'dietary_preferences',
  smokingPreference: 'smoking_preferences',
};

export const changeLogListingType = {
  tenancyLengthType: 'tenancy_length_type',
  availabilityFeedControlled: 'availability_feed_controlled',
  priceMin: 'price_min',
  tenancyLengthValue: 'tenancy_length_value',
  liveOn: 'live_on',
  discountValue: 'discount_value',
  moveInType: 'move_in_type',
  liveUntil: 'live_until',
  priceFeedControlled: 'price_feed_controlled',
  moveIn: 'move_in',
  moveOutType: 'move_out_type',
  type: 'type',
  discountType: 'discount_type',
  availability: 'availability',
  priceMax: 'price_max',
  moveOut: 'move_out',
  priceType: 'price_type',
  billingCycle: 'billing_cycle',
};

export const changeLogPropertyType = {
  propertyType: 'property_type',
  name: 'name',
  slug: 'slug',
  status: 'status',
  landlordName: 'landlord_name',
  displayCity: 'display_city',
  displayCountry: 'displayCountry',
  currency: 'currency',
  billingCycle: 'billing_cycle',
  totalBeds: 'total_beds',
  cancellationPeriodType: 'cancellation_period_type',
  cancellationPeriodValue: 'cancellation_period_value',
  cancellationProcess: 'cancellation_process',
  address: 'address',
  addressLine2: 'address_line2',
  postalCode: 'postal_code',
  shippingCity: 'shipping_city',
  latitude: 'latitude',
  longitude: 'longitude',
  displayarea: 'displayarea',
  headlineCn: 'headline_cn',
  descriptionCn: 'description_cn',
  headline: 'headline',
  description: 'description',
  rank: 'rank',
  rankingType: 'ranking_type',
  recommendedUniversities: 'recommended_universities',
  noPlaceNoPay: 'no_place_no_pay',
  noVisaNoPay: 'no_visa_no_pay',
  apCategory: 'ap_category',
  bookingJourney: 'booking_journey',
  depositTransferTime: 'deposit_transfer_time',
  rentTransferTime: 'rent_transfer_time',
};

export const auditPropertyModalList = {
  PROPERTY: 'PROPERTY',
  ADDRESS: 'ADDRESS',
  PROPERTY_ADDRESS: 'PROPERTY_ADDRESS',
  PROPERTY_FACILITY: 'PROPERTY_FACILITY',
  UNIT_TYPE: 'UNIT_TYPE',
  LISTING: 'LISTING',
};

export const sectionModalMapping = {
  details: [auditPropertyModalList.PROPERTY, auditPropertyModalList.PROPERTY_ADDRESS],
  address: [auditPropertyModalList.ADDRESS, auditPropertyModalList.PROPERTY_ADDRESS],
  facility: [auditPropertyModalList.PROPERTY_FACILITY],
  rooms: [auditPropertyModalList.UNIT_TYPE],
  listings: [auditPropertyModalList.LISTING],
};
